import { MultilineTextInputProps } from './MultilineTextInputProps';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { FieldValues, Path, PathValue, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const MultilineTextInput = <T extends FieldValues = FieldValues>({
  control,
  name,
  type,
  defaultValue = '',
  fullWidth = true,
  gridSize = 6,
  variant = 'outlined',
  label,
  shrink = true,
  lines = 4,
  readOnly = false,
  disabled = false,
  ...otherProps
}: MultilineTextInputProps<T>) => {
  const {
    field: { ref, onBlur, value, ...inputProps },
    fieldState: { error },
  } = useController({
    name: name as Path<T>,
    control,
    defaultValue: defaultValue as PathValue<T, Path<T>>,
  });
  const { t } = useTranslation();

  return (
    <Grid item xs={gridSize}>
      <TextField
        {...inputProps}
        {...otherProps}
        value={value ?? ''}
        inputRef={ref}
        onBlur={onBlur}
        error={!!error}
        helperText={error && t(error.message as string)}
        variant={variant}
        fullWidth={fullWidth}
        label={label}
        InputProps={{
          readOnly: readOnly,
        }}
        InputLabelProps={{ shrink: shrink }}
        type={type}
        multiline
        rows={lines}
        disabled={disabled}
      />
    </Grid>
  );
};
